// CareDetails.jsx
// DL 11/13/2k22

// Packages, Dependencies, Shared Libraries
import React, { useEffect, useState } from "react";
import { getImageURLFromDatabase } from "../../../DatabaseOperations";

// React Components
import CareInstruction from "./CareInstruction";

export const CareContainer = ({
  careInstructions,
  species,
  imageName,
  careView = "general",
  onChangeCareView = () => {},
  isOwned = false,
  environmentNotes = "",
  userNotes = "",
}) => {
  // Hooks
  const [plantImage, setPlantImage] = useState(<img alt="" />);
  const sanitizedEnvironmentNotes =
    typeof environmentNotes === "string" ? environmentNotes.trim() : "";
  const sanitizedUserNotes =
    typeof userNotes === "string" ? userNotes.trim() : "";
  const environmentPlaceholder =
    "Share light, humidity, and other environment details in the Leaflings app so your plant can tailor tips for its setup.";
  const userNotesPlaceholder =
    "Add your observations in the app. Your plant uses them to troubleshoot and offer targeted advice. Or just fun stuff like 'Talk like Borat'";

  useEffect(() => {
    let isMounted = true;

    // Species without stage art just show the empty oval
    if (!imageName) {
      return;
    }

    getImageURLFromDatabase("spriteComponents/plants/" + imageName).then(
      (imageURL) => {
        if (isMounted) {
          setPlantImage(
            <img className="plantBody" src={imageURL} alt={"Plant Body"} />
          );
        }
      },
      () => {} // Missing file in storage — keep the empty oval
    );

    return () => {
      isMounted = false;
    };
  }, [imageName]);

  return (
    <div
      className="bg-global-accent text-center text-xs rounded-2xl my-2 border border-leaf-green/30 shadow-card px-1 pb-1"
      id="careContainer"
    >
      <div className="px-2 pt-3">
        <div className="flex items-center justify-center gap-1.5 bg-leaf-green-soft rounded-full p-1 mx-auto max-w-[300px] font-global text-sm border border-leaf-green/25 shadow-sm">
          <button
            className={`flex-1 rounded-full px-3 py-1 font-semibold transition-all ${
              careView === "thisPlant"
                ? "bg-leaf-green-dark text-white shadow-sm"
                : "text-leaf-green-deep hover:bg-white/60"
            }`}
            onClick={() => onChangeCareView("thisPlant")}
          >
            This plant
          </button>
          <button
            className={`flex-1 rounded-full px-3 py-1 font-semibold transition-all ${
              careView === "general"
                ? "bg-leaf-green-dark text-white shadow-sm"
                : "text-leaf-green-deep hover:bg-white/60"
            }`}
            onClick={() => onChangeCareView("general")}
          >
            Species care
          </button>
        </div>
      </div>
      {careView === "general" ? (
        <>
          {/* <div
            id="careHeader"
            className="flex justify-between rounded-t-lg py-2 px- t2 "
          > */}
          <div className="px-3 pt-3 careTitle text-left font-global font-bold text-lg text-global-font">
            Caring for&nbsp;<em>{species}</em>
          </div>
          {/* </div> */}
          <div className="p-2 rounded-lg text-left space-y-2 text-leaf-brown">
            <div className="flex justify-between items-center">
              <div className="w-4/5 font-global text-xs py-0 px-2 leading-relaxed">
                {careInstructions.blurb}
              </div>
              <div className="flex flex-col justify-around">
                <div className="h-[90px] w-[120px] mr-2.5 rounded-[45px] bg-leaf-green-soft border border-leaf-green/20 flex flex-col justify-end overflow-hidden">
                  {plantImage}
                </div>
              </div>
            </div>

            <div>
              <CareInstruction
                instruction={{
                  displayString: careInstructions.waterDetails,
                  isLink: false,
                  link: "",
                }}
                image="water"
              />
              <CareInstruction
                instruction={{
                  displayString: careInstructions.lightDetails,
                  isLink: false,
                  link: "",
                }}
                image="light"
              />
              <CareInstruction
                instruction={{
                  displayString: careInstructions.moreDetails,
                  isLink: false,
                  link: "",
                }}
                image="plusSign"
              />{" "}
            </div>
          </div>
        </>
      ) : (
        <div className="px-3 py-3 text-left text-leaf-brown font-global space-y-4">
          <div className="space-y-1.5">
            <p className="text-sm font-semibold tracking-wide">
              Environment notes
            </p>
            <div
              className={`rounded-2xl border text-xs px-3 py-3 ${
                sanitizedEnvironmentNotes
                  ? "border-leaf-green/25 bg-leaf-green-soft/50 text-leaf-brown"
                  : "border-dashed border-leaf-green/40 bg-white/70 text-leaf-brown-soft"
              }`}
            >
              {sanitizedEnvironmentNotes || environmentPlaceholder}
            </div>
          </div>
          <div className="space-y-1.5">
            <p className="text-sm font-semibold tracking-wide">Your notes</p>
            <div
              className={`rounded-2xl border text-xs px-3 py-3 ${
                sanitizedUserNotes
                  ? "border-leaf-green/25 bg-leaf-green-soft/50 text-leaf-brown"
                  : "border-dashed border-leaf-green/40 bg-white/70 text-leaf-brown-soft"
              }`}
            >
              {sanitizedUserNotes || userNotesPlaceholder}
            </div>
          </div>
          <div className="space-y-1">
            <p className="text-sm font-semibold tracking-wide">Care plan</p>
            <p className="text-sm italic text-leaf-green-dark">
              Personalized plans are growing in the app soon.
            </p>
          </div>
        </div>
      )}
    </div>
  );
}; // End CareContainer

export default CareContainer;
